import React, { useEffect, useState } from 'react';
import {
  Typography,
  Container,
  CircularProgress,
  Grid,
} from '@mui/material';

import TBajaFacturas from '../TBajaFacturas';
import { useStateValue } from '../../../contexto/store';
import { obtenerFacturasPendientesDeBaja } from '../../../actions/CobranzasAction';

export default function PanelFacturasPendientesDeBaja(props) {
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [rows, setRows] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false);
  useEffect(() => {
    obtenerFacturasPendientesDeBaja(sesionUsuario.usuario.id).then(
      (response) => {
        if (response.status === 200) {
          setRows(response.data);
          setDatosCargados(true);
        } else {
          console.log('ERROR EN TRAER FACTURAS');
        }
      }
    );
  }, [sesionUsuario]);
  return (
    <Container maxWidth="lg" justify="center">
      <Typography align="center" variant="h5">
        FACTURAS PENDIENTES DE BAJA
      </Typography>
      <br />
      {datosCargados ? (
        <TBajaFacturas rows={rows} setRows={setRows} />
      ) : (
        <Grid container justify="center" >
          <CircularProgress />
          <br />
          <Typography>Cargando...</Typography>
        </Grid>
      )}
    </Container>
  );
}
